import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  user: {},
  loading: false,
  isUserLogout: false,
  errorMsg: "", // for error message
};

const loginSlice  = createSlice({
  name: "login",
  initialState,
  reducers: {
    apiError(state, action) {
      state.loading = false;
      state.isUserLogout = false;
      state.errorMsg = action.payload.message || "Un problème technique est survenu !";
    },
    loginSuccess(state) {
      state.loading = false;
      state.errorMsg = "";
      state.isUserLogout = false;
    },
    shouldResync(state, action) {
      state.loading = false;
      state.user = {username: action.payload.username, password: action.payload.password};
    },
    otpValidated(state, action) {
      state.loading = false;
      state.user = {username: action.payload.username};
      state.errorMsg = "";
    },
    logoutUserSuccess(state, action) {
      state.isUserLogout = true
    },
    reset_login_flag(state) {
      state.loading = false;
      state.errorMsg = "";
    }
  },
});

export const {
  apiError,
  loginSuccess,
  shouldResync,
  otpValidated,
  logoutUserSuccess,
  reset_login_flag
} = loginSlice.actions

export default loginSlice.reducer;